// Mock data for IhsanOne SuperApp

export const campaigns = [
  {
    id: 1,
    title: 'Ramadan Food Packages',
    description: 'Provide nutritious food packages to families in need during the blessed month of Ramadan.',
    image: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?w=600&q=80',
    category: 'Ramadan',
    raised: 45000,
    goal: 100000,
    daysLeft: 12,
    donors: 234
  },
  {
    id: 2,
    title: 'Build a Well in Rural Village',
    description: 'Help us build a well to provide clean water access to a rural community.',
    image: 'https://images.unsplash.com/photo-1594398901394-4e34939a4fd0?w=600&q=80',
    category: 'Emergency',
    raised: 15000,
    goal: 25000,
    daysLeft: 8,
    donors: 89
  },
  {
    id: 3,
    title: 'Medical Equipment for Community Clinic',
    description: 'Support our community health center by funding essential medical equipment.',
    image: 'https://images.unsplash.com/photo-1584982751601-97dcc096659c?w=600&q=80',
    category: 'Health',
    raised: 32000,
    goal: 50000,
    daysLeft: 25,
    donors: 156
  },
  {
    id: 4,
    title: 'Emergency Relief for Flood Victims',
    description: 'Immediate relief supplies for families affected by recent flooding.',
    image: 'https://images.unsplash.com/photo-1547996160-81dfa63595aa?w=600&q=80',
    category: 'Emergency',
    raised: 68000,
    goal: 75000,
    daysLeft: 5,
    donors: 412,
    urgent: true
  }
];

export const courses = [
  {
    id: 1,
    title: 'Ulum Ihsan — Quran & Islamic Knowledge',
    description: 'Weekly classes at your rental block with certified asatizah. Free for residents.',
    category: 'Islamic Studies',
    duration: 'Weekly',
    format: 'In-person at your block',
    level: 'All levels',
    badge: 'Community'
  },
  {
    id: 2,
    title: 'Funeral Essentials for Professionals',
    description: 'SkillsFuture-eligible course on Muslim funeral rites and administration. Via filament.sg.',
    category: 'Professional',
    duration: '2 days',
    format: 'Classroom',
    level: 'Beginner',
    badge: 'SkillsFuture'
  },
  {
    id: 3,
    title: 'Engaging Beneficiaries with Dignity',
    description: 'Practical skills for volunteers and staff on respectful community interaction.',
    category: 'Community Skills',
    duration: '3 hours',
    format: 'Workshop',
    level: 'All levels',
    badge: 'Volunteer'
  },
  {
    id: 4,
    title: 'Theory of Change — How Impact is Measured',
    description: 'Understand how MTFA tracks community outcomes using WHOQOL-BREF and sector frameworks.',
    category: 'Impact',
    duration: '1 hour',
    format: 'Online',
    level: 'Intermediate',
    badge: 'Impact'
  }
];

export const volunteerOpportunities = [
  {
    id: 1,
    title: 'Ihsan Care Roadshow — Marsiling',
    description: 'Join our team at Marsiling estate. Help with resident engagement, form assistance, and welfare screening at the booth.',
    category: 'Community Outreach',
    location: 'Marsiling, Singapore',
    date: 'August 2026',
    duration: '4 hours',
    volunteers: 3,
    capacity: 8,
    urgent: false
  },
  {
    id: 2,
    title: 'JagaMusala Cleaning Drive',
    description: 'Help clean and maintain suraus (musolas) across Singapore as part of our national JagaMusala movement.',
    category: 'Community',
    location: 'Various locations',
    date: 'Monthly',
    duration: '2 hours',
    volunteers: 24,
    capacity: 50,
    urgent: false
  },
  {
    id: 3,
    title: 'Ulum Ihsan Class Support',
    description: 'Assist asatizah with class logistics, materials, and resident coordination at rental block weekly classes.',
    category: 'Education',
    location: 'Various rental blocks',
    date: 'Weekly',
    duration: '2 hours',
    volunteers: 5,
    capacity: 10,
    urgent: false
  },
  {
    id: 4,
    title: 'Corporate CSR — Bring Your Team',
    description: 'Partner with MTFA for a structured CSR half-day. Activities tailored to your team size and interest.',
    category: 'Corporate',
    location: 'MTFA, 5 Mattar Road',
    date: 'By arrangement',
    duration: 'Half day',
    volunteers: 0,
    capacity: 30,
    urgent: false,
    corporate: true
  }
];

export const services = [
  // PILLAR 1 — RECEIVE SUPPORT
  {
    id: 'financial-assistance',
    title: 'Financial Assistance',
    description: 'Apply for Ihsan Aid support',
    icon: 'hand-coins',
    color: 'primary',
    pillar: 'receive',
    category: 'Services'
  },
  {
    id: 'ihsan-casket',
    title: 'Ihsan Casket',
    description: 'Respectful Muslim burial services, 24/7',
    icon: 'nisan',
    color: 'primary',
    pillar: 'receive',
    category: 'Services',
    featured: true
  },
  {
    id: 'kidney-care',
    title: 'Kidney Care',
    description: 'Subsidised dialysis services',
    icon: 'heart',
    color: 'primary',
    pillar: 'receive',
    category: 'Dialysis'
  },
  {
    id: 'bursaries',
    title: 'Bursaries & Scholarships',
    description: 'Education support for families',
    icon: 'graduation-cap',
    color: 'primary',
    pillar: 'receive',
    category: 'Services'
  },
  // PILLAR 2 — GIVE BACK
  {
    id: 'volunteer',
    title: 'Volunteer',
    description: 'Join a project or one-off activity',
    icon: 'users',
    color: 'accent',
    pillar: 'give',
    category: 'Community'
  },
  {
    id: 'corporate-csr',
    title: 'Corporate CSR',
    description: 'Bring your team, pledge resources',
    icon: 'building',
    color: 'accent',
    pillar: 'give',
    category: 'Community'
  },
  {
    id: 'sponsor',
    title: 'Sponsor a Benefit',
    description: 'Fund discounted community services',
    icon: 'gift',
    color: 'accent',
    pillar: 'give',
    category: 'Community'
  },
  // PILLAR 3 — LEARN
  {
    id: 'ulum-ihsan',
    title: 'Ulum Ihsan',
    description: 'Islamic learning at your rental block',
    icon: 'book-open',
    color: 'success',
    pillar: 'learn',
    category: 'Learning'
  },
  {
    id: 'filament',
    title: 'filament.sg',
    description: 'Professional training, SkillsFuture eligible',
    icon: 'award',
    color: 'success',
    pillar: 'learn',
    category: 'Learning'
  },
  {
    id: 'impact-stories',
    title: 'Our Impact',
    description: 'How we measure what we do',
    icon: 'trending-up',
    color: 'success',
    pillar: 'learn',
    category: 'Learning'
  }
];

export const heroSlides = [
  {
    id: 1,
    title: 'Building A Caring Community',
    subtitle: 'Together for a stronger Ihsan family & neighbourhood.',
    image: '/images/hero-slide-1-community.jpeg'
  },
  {
    id: 2,
    title: 'Everyday Ihsan, Everyday Good',
    subtitle: 'Small acts of kindness, tracked and celebrated together.',
    image: '/images/hero-slide-2-everyday-ihsan.jpeg'
  },
  {
    id: 3,
    title: 'Your Ihsan Points Await',
    subtitle: 'Learn, serve and give to unlock badges and rewards.',
    image: '/images/hero-slide-3-ihsan-points.jpeg'
  }
];

// Featured cards are pointers to real hub items rather than standalone copy —
// title, org and image are resolved from the linked item at render time so a
// featured card can never advertise something its destination doesn't match.
export const featuredForYou = [
  {
    id: 'featured-learn-1',
    linkType: 'learn',
    linkId: 'ulum-ihsan-course',
    tag: 'Learn',
    tagColor: 'bg-primary',
    count: '124 learners'
  },
  {
    id: 'featured-volunteer-1',
    linkType: 'volunteer',
    linkId: 'grounded-youth-forum',
    tag: 'Volunteer',
    tagColor: 'bg-indigo-800',
    count: '32 volunteers'
  }
];

// Popular Services pills. `collection` names the real set of cards shown when
// the pill is active, so this section browses the same content as the hubs
// rather than a parallel list of icon tiles.
export const popularCategories = [
  { id: 'Services', label: 'Services', collection: 'services' },
  { id: 'Learning', label: 'Learning', collection: 'learn' },
  { id: 'Community', label: 'Community', collection: 'volunteer' },
  { id: 'Dialysis', label: 'Dialysis', collection: 'dialysis' },
  { id: 'Casket', label: 'Casket', collection: 'casket' },
  { id: 'Give', label: 'Give', collection: 'give' }
];

// The three things shown as image cards in the Services hub. Dialysis now
// lives in its own Explore category, so it is not duplicated here. Ids match
// `services` above so every card reuses the existing routing. Each service
// opens the same detail page as every other card, so it carries the same
// blocks: description, facts, highlights and its own CTA. The CTA label
// doubles as the entry point into that service's bespoke flow.
export const serviceHubItems = [
  {
    id: 'financial-assistance',
    tag: 'Aid',
    tagColor: 'bg-primary',
    title: 'Financial Aid',
    org: 'Ihsan Aid',
    date: '48hr response time',
    image: 'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=800&q=80',
    ctaLabel: 'Apply for Assistance',
    ctaSuccessLabel: 'Application Started',
    description:
      'Short-term financial help for Muslim families in Singapore facing hardship — rental arrears, utilities, daily essentials and medical bills. Every application is assessed confidentially by a caseworker.',
    facts: [
      { label: 'Response', value: '48 hours' },
      { label: 'Assessment', value: 'PCI-based' },
      { label: 'Cost', value: 'Free' },
      { label: 'Language', value: 'EN / MY' }
    ],
    highlights: [
      'One application covers rental, utilities and daily essentials.',
      'A named caseworker follows your household from start to finish.',
      'Referrals to Kidney Care, bursaries and befriending where relevant.',
      'Track your application status any time from the Saved tab.'
    ]
  },
  {
    id: 'ihsan-casket',
    tag: 'Bereavement',
    tagColor: 'bg-indigo-800',
    title: 'Ihsan Casket',
    org: 'Muslim burial services',
    date: 'Available 24/7',
    image: '/images/mtfa-ihsan-casket.jpg',
    ctaLabel: 'Arrange a Burial',
    ctaSuccessLabel: 'Request Started',
    description:
      'End-to-end Muslim burial arranged with dignity, any hour of the day. We collect, perform ghusl and kafan, and handle the paperwork and burial slot so the family can focus on their loved one.',
    facts: [
      { label: 'Available', value: '24 / 7' },
      { label: 'Collection', value: 'Within 2 hrs' },
      { label: 'Packages', value: 'From $0' },
      { label: 'Coverage', value: 'Islandwide' }
    ],
    highlights: [
      'Collection from home, hospital or mortuary at any hour.',
      'Ghusl and kafan performed by trained MTFA staff.',
      'Burial slot, permits and NEA fees handled for you.',
      'A shareable tracker so relatives can follow the arrangements.'
    ]
  },
  {
    id: 'bursaries',
    tag: 'Education',
    tagColor: 'bg-amber-600',
    title: 'Bursaries & Scholarships',
    org: 'MTFA Education',
    date: 'Intake open',
    image: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=800&q=80',
    ctaLabel: 'Apply for a Bursary',
    ctaSuccessLabel: 'Application Started',
    description:
      'Education support from primary school through university, so no child in our community drops out over money. Bursaries cover fees and materials; scholarships recognise strong academic promise.',
    facts: [
      { label: 'Levels', value: 'Pri – Uni' },
      { label: 'Intake', value: 'Open now' },
      { label: 'Award', value: 'Up to $6k' },
      { label: 'Renewal', value: 'Yearly' }
    ],
    highlights: [
      'Covers school fees, uniforms, books and exam materials.',
      'One form per household, however many children apply.',
      'Renewable each year while your circumstances hold.',
      'Recipients get first access to Ulum Ihsan and filament.sg classes.'
    ]
  },
  {
    id: 'ulum-asatizah',
    tag: 'Teaching',
    tagColor: 'bg-emerald-700',
    title: 'Ulum Ihsan Asatizah',
    org: 'For administration of Ulum Ihsan classes',
    date: 'Log a session',
    image: '/images/ulum-ihsan-dua-surah-hero.jpeg',
    ctaLabel: 'Log a Class Session',
    ctaSuccessLabel: 'Continue',
    description:
      'The session form asatizah use after each Ulum Ihsan class — date, hours, host, class, roll call and the lesson taught. Submissions feed the monthly timesheet so finance can bill without re-keying job forms.',
    facts: [
      { label: 'Who', value: 'Asatizah' },
      { label: 'When', value: 'After each class' },
      { label: 'Hours', value: '1–3 hr blocks' },
      { label: 'Roll call', value: 'Pre-checked' }
    ],
    highlights: [
      'One form per session, even if you teach more than one class a week.',
      'Host location is captured as evidence for host payment.',
      'Students start ticked present — uncheck only those who were absent.',
      'Hours here become the timesheet that finance uses to pay you.'
    ]
  },
  // TODO(rbac): hide staffOnly cards unless the signed-in role is DIO / duty officer.
  {
    id: 'daily-attendance',
    tag: 'Staff',
    tagColor: 'bg-slate-700',
    title: 'Daily Student Attendance',
    org: 'For duty officers logging daily programme and movement',
    date: 'Staff register',
    image: '/images/hero-slide-1-community.jpeg',
    ctaLabel: 'Open the register',
    ctaSuccessLabel: 'Continue',
    staffOnly: true,
    description:
      'Duty-officer register for daily programme attendance and movement. Tap a case number (1–40) — names never appear on this screen. Logs stamp the officer on duty and flag anyone out past expected return.',
    facts: [
      { label: 'Who', value: 'Duty officers' },
      { label: 'Cases', value: '1–40' },
      { label: 'Log', value: 'Attendance + movement' },
      { label: 'Flag', value: 'Overdue return' }
    ],
    highlights: [
      'Case number is the only identifier shown — no resident names.',
      'Mark the daily programme attended or absent, with short remarks.',
      'Going out records destination, expected return and who authorised it.',
      'Whereabouts board lists everyone currently out; overdue returns show red.'
    ]
  }
];

// Roster and pickers for the Ulum Ihsan Asatizah session form. Classes carry
// their own learners so the roll call updates when the asatizah picks a class.
export const ulumAsatizahAdmin = {
  durations: [
    { id: 1, label: '1 hour' },
    { id: 2, label: '2 hours' },
    { id: 3, label: '3 hours' }
  ],
  startTimes: [
    { id: '09:00', label: '9:00 AM' },
    { id: '10:00', label: '10:00 AM' },
    { id: '16:00', label: '4:00 PM' },
    { id: '19:00', label: '7:00 PM' },
    { id: '19:30', label: '7:30 PM' },
    { id: '20:00', label: '8:00 PM' }
  ],
  hosts: [
    { id: 'eunos', name: 'Blk 12 Eunos Crescent', area: 'Eunos · rental block' },
    { id: 'circuit', name: 'Blk 51 Circuit Road', area: 'MacPherson · rental block' },
    { id: 'bendemeer', name: 'Blk 33 Bendemeer Road', area: 'Kallang · rental block' },
    { id: 'alkaff', name: 'Masjid Alkaff Kampung Melayu', area: 'Kaki Bukit' },
    { id: 'mattar', name: 'MTFA HQ, 5 Mattar Road', area: 'MacPherson' }
  ],
  lessons: [
    { id: 'pillars', title: 'The 5 Pillars of Islam' },
    { id: 'articles', title: 'The 6 Articles of Faith' },
    { id: 'wudu', title: 'Wudu & Salah (Prayer)' },
    { id: 'fatihah', title: 'Surah Al-Fatihah' },
    { id: 'ikhlas', title: 'Surah Al-Ikhlas' },
    { id: 'adab', title: 'Good Manners in Islam' },
    { id: 'revision', title: 'Weekly revision & recap' }
  ],
  classes: [
    {
      id: 'fardhu-l1',
      title: 'Fardhu Ain — Level 1',
      schedule: 'Tue · 7:30 PM',
      students: [
        { id: 's1', name: 'Aisyah Rahman' },
        { id: 's2', name: 'Danial Hakim' },
        { id: 's3', name: 'Farah Izzati' },
        { id: 's4', name: 'Hafiz Abdullah' },
        { id: 's5', name: 'Irfan Syafiq' },
        { id: 's6', name: 'Maryam Zahra' },
        { id: 's7', name: 'Nurul Huda' },
        { id: 's8', name: 'Rayyan Firdaus' },
        { id: 's9', name: 'Siti Aminah' },
        { id: 's10', name: 'Zaki Iman' }
      ]
    },
    {
      id: 'dua-l1',
      title: 'Dua & Surah — Level 1',
      schedule: 'Wed · 8:00 PM',
      students: [
        { id: 's11', name: 'Amirul Hakim' },
        { id: 's12', name: 'Balqis Sofea' },
        { id: 's13', name: 'Danish Irfan' },
        { id: 's14', name: 'Hana Maisarah' },
        { id: 's15', name: 'Luqman Hakim' },
        { id: 's16', name: 'Nadira Amani' },
        { id: 's17', name: 'Qayyum Zain' },
        { id: 's18', name: 'Yasmin Irdina' }
      ]
    },
    {
      id: 'fardhu-l2',
      title: 'Fardhu Ain — Level 2',
      schedule: 'Thu · 7:00 PM',
      students: [
        { id: 's19', name: 'Afiq Danish' },
        { id: 's20', name: 'Batrisyia Nura' },
        { id: 's21', name: 'Emir Zuhair' },
        { id: 's22', name: 'Hidayah Salsabila' },
        { id: 's23', name: 'Iman Fatihah' },
        { id: 's24', name: 'Khairul Anwar' },
        { id: 's25', name: 'Liyana Sofea' },
        { id: 's26', name: 'Mikail Harith' },
        { id: 's27', name: 'Nabilah Izzah' },
        { id: 's28', name: 'Putri Ameera' },
        { id: 's29', name: 'Syafiq Imran' },
        { id: 's30', name: 'Zahirah Insyirah' }
      ]
    },
    {
      id: 'youth',
      title: 'Jumaat Youth Circle',
      schedule: 'Fri · 4:00 PM',
      students: [
        { id: 's31', name: 'Adam Hariz' },
        { id: 's32', name: 'Fatin Aqilah' },
        { id: 's33', name: 'Haziq Danish' },
        { id: 's34', name: 'Izzah Maisara' },
        { id: 's35', name: 'Johan Arif' },
        { id: 's36', name: 'Raihana Sofea' },
        { id: 's37', name: 'Umar Zayd' }
      ]
    }
  ]
};

// MTFA's three dialysis centres. Shape matches `learnHubItems` for the card
// grid, plus the `facts`/`highlights` blocks the shared detail page renders.
export const dialysisCentres = [
  {
    id: 'henderson-centre',
    title: 'Henderson Centre',
    org: 'MTFA Dialysis',
    date: 'Mon–Sat · 3 shifts daily',
    tag: 'Dialysis',
    tagColor: 'bg-rose-600',
    location: '108 Henderson Road, Singapore 159544',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80',
    description:
      'Our flagship centre in the south, with 18 dialysis stations and a dedicated care team. Subsidised sessions are available for households that qualify under our means-test.',
    facts: [
      { label: 'Stations', value: '18' },
      { label: 'Shifts', value: '7am · 12pm · 5pm' },
      { label: 'Nearest MRT', value: 'Redhill' },
      { label: 'Subsidy', value: 'Up to 100%' }
    ],
    highlights: [
      'Wheelchair accessible with drop-off bay',
      'On-site renal dietitian every Tuesday',
      'Transport arrangement for eligible patients',
      'Malay, English and Mandarin speaking staff'
    ]
  },
  {
    id: 'nooris-centre',
    title: 'Nooris Centre',
    org: 'MTFA Dialysis',
    date: 'Mon–Sat · 3 shifts daily',
    tag: 'Dialysis',
    tagColor: 'bg-rose-600',
    location: '51 Kallang Bahru, Singapore 339065',
    image: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&q=80',
    description:
      'A quieter centre in the central east, built around longer evening shifts for patients who work during the day. Caregivers are welcome to stay in the family lounge.',
    facts: [
      { label: 'Stations', value: '12' },
      { label: 'Shifts', value: '8am · 1pm · 6pm' },
      { label: 'Nearest MRT', value: 'Bendemeer' },
      { label: 'Subsidy', value: 'Up to 100%' }
    ],
    highlights: [
      'Extended evening shift for working patients',
      'Family lounge for caregivers',
      'Free blood investigation every quarter',
      'Counselling referrals through Ihsan Aid'
    ]
  },
  {
    id: 'yishun-centre',
    title: 'Yishun Centre',
    org: 'MTFA Dialysis',
    date: 'Mon–Sat · 3 shifts daily',
    tag: 'Dialysis',
    tagColor: 'bg-rose-600',
    location: '2 Yishun Street 22, Singapore 768579',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&q=80',
    description:
      'Our newest centre, serving families in the north. Opened in 2025 with the most recent machines and a training bay for patients learning home dialysis.',
    facts: [
      { label: 'Stations', value: '16' },
      { label: 'Shifts', value: '7am · 12pm · 5pm' },
      { label: 'Nearest MRT', value: 'Khatib' },
      { label: 'Subsidy', value: 'Up to 100%' }
    ],
    highlights: [
      'Home-dialysis training programme',
      'Sheltered walkway from Khatib MRT',
      'Paediatric-friendly treatment bay',
      'Weekend shifts for caregivers who work weekdays'
    ]
  }
];

// Ihsan Casket service packages.
export const casketPackages = [
  {
    id: 'casket-standard',
    title: 'Standard Package',
    org: 'Ihsan Casket',
    date: '$1,800 · all inclusive',
    price: '$1,800',
    tag: 'Package',
    tagColor: 'bg-indigo-800',
    location: 'Islandwide · available 24/7',
    image: '/images/mtfa-ihsan-casket.jpg',
    description:
      'Our complete burial service, arranged end to end by our team so the family only needs to be present. Covers collection, preparation, prayers and burial at Pusara Aman.',
    facts: [
      { label: 'Total cost', value: '$1,800' },
      { label: 'Response', value: 'Within 2 hours' },
      { label: 'Availability', value: '24 hours' },
      { label: 'Burial site', value: 'Pusara Aman' }
    ],
    highlights: [
      'Collection from home, hospital or mortuary',
      'Ghusl and kafan by trained staff',
      'Casket, transport and burial plot arrangement',
      'Solat janazah coordination at your mosque',
      'Death certificate and permit administration'
    ]
  },
  {
    id: 'casket-subsidised',
    title: 'Subsidised Package',
    org: 'Ihsan Casket',
    date: 'Means-tested · from $0',
    price: 'From $0',
    tag: 'Subsidised',
    tagColor: 'bg-primary',
    location: 'Islandwide · available 24/7',
    image: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&q=80',
    description:
      'The same full service as our Standard Package, with the cost partly or fully covered by MTFA for families facing financial hardship. No family is turned away.',
    facts: [
      { label: 'Total cost', value: 'From $0' },
      { label: 'Response', value: 'Within 2 hours' },
      { label: 'Assessment', value: 'Same day' },
      { label: 'Burial site', value: 'Pusara Aman' }
    ],
    highlights: [
      'Everything included in the Standard Package',
      'Means-test completed by our team, not the family',
      'Assistance applied on the spot — no waiting period',
      'Supported by Ihsan Aid and public donations',
      'Follow-up support for the household afterwards'
    ]
  }
];

// The five ways to give. `amounts` seeds the checkout's denomination buttons.
export const givingOptions = [
  {
    id: 'give-darul-ihsan',
    title: 'Donating to Darul Ihsan Orphanages',
    org: 'Darul Ihsan',
    date: 'One-time or recurring',
    tag: 'Orphanages',
    tagColor: 'bg-indigo-800',
    cadence: 'once',
    amounts: [30, 50, 100, 250],
    location: 'Darul Ihsan Orphanage, Singapore',
    image: 'https://images.unsplash.com/photo-1594708767771-a7502209ff51?w=800&q=80',
    description:
      'Support the daily running of our orphanages — meals, schooling, healthcare and enrichment for children under MTFA’s care. Your gift goes directly to the homes.',
    facts: [
      { label: 'Children supported', value: '180' },
      { label: 'Cost per child', value: '$420 / month' },
      { label: 'Homes', value: '2' },
      { label: 'Tax deductible', value: '2.5×' }
    ],
    highlights: [
      'Covers meals, uniforms and school fees',
      'Funds tuition and enrichment programmes',
      'Supports resident house-parents and counsellors',
      'Annual impact report sent to all donors'
    ]
  },
  {
    id: 'give-sedekah-subuh',
    title: 'Daily Sedekah Subuh donations',
    org: 'IhsanOne',
    date: 'Daily · from $1 a day',
    tag: 'Daily',
    tagColor: 'bg-amber-600',
    cadence: 'daily',
    amounts: [1, 2, 5, 10],
    location: 'Automatic daily giving',
    image: 'https://images.unsplash.com/photo-1542816417-0983c9c9ad53?w=800&q=80',
    description:
      'A small amount given every morning after Subuh. Set it once and let the habit carry — the barakah of consistency matters more than the size of the gift.',
    facts: [
      { label: 'Charged', value: 'Daily after Subuh' },
      { label: 'Minimum', value: '$1 a day' },
      { label: 'Pause anytime', value: 'Yes' },
      { label: 'Tax deductible', value: '2.5×' }
    ],
    highlights: [
      'Deducted quietly each morning — no reminders needed',
      'Pooled into the most urgent needs that week',
      'Pause, change or stop from your Me tab',
      'Monthly summary of where your sedekah went'
    ]
  },
  {
    id: 'give-jumaat',
    title: 'Weekly Jumaat donations',
    org: 'IhsanOne',
    date: 'Every Friday',
    tag: 'Weekly',
    tagColor: 'bg-teal-600',
    cadence: 'weekly',
    amounts: [5, 10, 20, 50],
    location: 'Automatic weekly giving',
    image: 'https://images.unsplash.com/photo-1512632578888-169bbbc64f33?w=800&q=80',
    description:
      'Give every Friday, the way many families already set aside something before Jumaat prayers. Collected weekly and channelled to families awaiting assistance.',
    facts: [
      { label: 'Charged', value: 'Every Friday' },
      { label: 'Typical gift', value: '$10 a week' },
      { label: 'Pause anytime', value: 'Yes' },
      { label: 'Tax deductible', value: '2.5×' }
    ],
    highlights: [
      'Timed to Jumaat, so the habit has an anchor',
      'Goes to households in the assistance queue',
      'Receipt consolidated once a year for tax relief',
      'Change the amount any week you like'
    ]
  },
  {
    id: 'give-monthly',
    title: 'Monthly donations',
    org: 'IhsanOne',
    date: 'Monthly standing gift',
    tag: 'Monthly',
    tagColor: 'bg-primary',
    cadence: 'monthly',
    amounts: [20, 50, 100, 200],
    location: 'Automatic monthly giving',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80',
    description:
      'The steadiest way to help. A predictable monthly gift lets us commit to long-term care — dialysis subsidies, bursaries and orphanage places that must be funded year-round.',
    facts: [
      { label: 'Charged', value: 'Monthly' },
      { label: 'Most chosen', value: '$50 a month' },
      { label: 'Pause anytime', value: 'Yes' },
      { label: 'Tax deductible', value: '2.5×' }
    ],
    highlights: [
      'Funds commitments we cannot make on one-off gifts',
      '$50 a month covers one dialysis session',
      'Adjust or pause from your Me tab',
      'Priority invitations to centre visits and briefings'
    ]
  },
  {
    id: 'give-once-off',
    title: 'Once off Donations',
    org: 'IhsanOne',
    date: 'Give once, any amount',
    tag: 'One-time',
    tagColor: 'bg-rose-600',
    cadence: 'once',
    amounts: [20, 50, 100, 500],
    location: 'Single gift',
    image: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=800&q=80',
    description:
      'A single gift, given whenever you are moved to. Useful for Ramadan, an emergency appeal, or simply when something good has happened and you want to mark it.',
    facts: [
      { label: 'Charged', value: 'Once' },
      { label: 'Any amount', value: 'From $5' },
      { label: 'Receipt', value: 'Emailed instantly' },
      { label: 'Tax deductible', value: '2.5×' }
    ],
    highlights: [
      'No commitment and nothing to cancel',
      'Choose a cause or let MTFA allocate it',
      'Instant tax-deductible receipt by email',
      'Give in someone else’s name if you wish'
    ]
  }
];

// Explore "Categories" tile grid. `target` decides what a tile does:
//   tab -> open a hub (Services, Learn, Volunteer, Give, Dialysis, Casket)
// Each tile previews its hub with that hub's own banner photo, so the tile and
// the page it opens show the same picture. Dialysis is the exception: there is
// no dignified stock photo of a patient on treatment, so it keeps the drawn
// icon from CategoryArt.
//
// `badge` is optional flash copy pinned to the tile's corner. `subtitle` is kept
// for search, which matches against it, but the tile itself shows the label only.
export const exploreCategories = [
  {
    id: 'services',
    label: 'Services',
    subtitle: 'Aid & Care',
    badge: 'NEW',
    image: '/images/hero-slide-1-community.jpeg',
    imagePosition: '50% 42%',
    target: { type: 'tab', value: 'services' }
  },
  {
    id: 'learning',
    label: 'Learning',
    subtitle: 'Courses & Skills',
    badge: 'NEW',
    image: '/images/learn-hub-hero.jpeg',
    imagePosition: '58% 50%',
    target: { type: 'tab', value: 'learn' }
  },
  {
    id: 'community',
    label: 'Community',
    subtitle: 'Events & Programs',
    badge: 'NEW',
    image: '/images/volunteer-hub-hero.jpeg',
    imagePosition: '50% 38%',
    target: { type: 'tab', value: 'volunteer' }
  },
  {
    id: 'dialysis',
    label: 'Dialysis',
    subtitle: 'Our 3 Centres',
    image: '/images/category-dialysis.png',
    imagePosition: '50% 45%',
    target: { type: 'tab', value: 'dialysis' }
  },
  {
    id: 'casket',
    label: 'Casket',
    subtitle: 'Burial Packages',
    image: '/images/category-casket.png',
    imagePosition: '50% 42%',
    target: { type: 'tab', value: 'casket' }
  },
  {
    id: 'give',
    label: 'Give',
    subtitle: 'Donate & Share',
    image: '/images/hero-slide-2-everyday-ihsan.jpeg',
    imagePosition: '50% 45%',
    target: { type: 'tab', value: 'give' }
  }
];

// Placeholder needs/preference checkboxes shown after sign-up for each service.
// Copy here is illustrative and expected to be replaced once the real intake
// questions are confirmed. `default` covers anything without a bespoke list.
export const serviceNeedsOptions = {
  'kidney-care': [
    'Subsidised dialysis sessions',
    'Transport to and from the centre',
    'Help with medical bill assessment',
    'Dietary and nutrition guidance',
    'Caregiver support and respite'
  ],
  bursaries: [
    'Primary or secondary school fees',
    'ITE, polytechnic or university fees',
    'Books, uniforms and school supplies',
    'Enrichment or tuition support',
    'Laptop or digital learning device'
  ],
  volunteer: [
    'Event support on weekends',
    'Skills-based or professional volunteering',
    'Befriending and home visits',
    'Administrative and back-office help',
    'Tutoring and youth mentoring'
  ],
  'corporate-csr': [
    'Half-day team volunteering',
    'Sponsored community event',
    'In-kind donation of goods',
    'Employee giving programme',
    'Skills transfer or training workshop'
  ],
  sponsor: [
    'Sponsor a dialysis session',
    'Sponsor a student bursary',
    'Sponsor a funeral service',
    'Sponsor a class at a rental block',
    'Let MTFA allocate where needed most'
  ],
  'ulum-ihsan': [
    'Quran recitation and tajweed',
    'Islamic studies for adults',
    'Classes for children and teens',
    'Weekend timing preferred',
    'Weekday evening timing preferred'
  ],
  filament: [
    'SkillsFuture-eligible courses',
    'Funeral rites and administration',
    'Community engagement skills',
    'Leadership and management',
    'Classroom format preferred'
  ],
  'impact-stories': [
    'Receive our annual impact report',
    'Case studies and beneficiary stories',
    'Outcome measurement methodology',
    'Invitations to impact briefings',
    'Research and data partnerships'
  ],
  default: [
    'I would like to be contacted about this',
    'Send me updates and upcoming dates',
    'I need help understanding eligibility',
    'I am applying on behalf of someone else',
    'I prefer to be contacted on WhatsApp'
  ]
};

// updatesFeed mock removed 2026-09-21: Moments.jsx now fetches the live
// Directus `updates_public` view exclusively (see lib/updates.js). When the
// live feed is unavailable/empty the tab shows an honest empty state instead
// of stale mock content. Keeping this export around only served to leak
// launch-time promises into the production bundle.

export const volunteerHubItems = [
  {
    id: 'mosque-donation-drive',
    tag: 'Community',
    tagColor: 'bg-teal-600',
    title: 'Mosque Donation Drive (MDD)',
    org: 'Masjid Wak Tanjong',
    location: 'Masjid Wak Tanjong',
    date: 'Sat, 30 Aug 2026',
    time: '9:00 AM – 1:00 PM',
    image: 'https://images.unsplash.com/photo-1569929919600-59123640bc02?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1569929919600-59123640bc02?w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1569929919600-59123640bc02?w=1200&q=80',
      'https://images.unsplash.com/photo-1593113598332-cd288d649433?w=1200&q=80'
    ],
    carouselExtra: { type: 'map', label: 'Masjid Wak Tanjong' },
    description: 'Help us collect and distribute essential items to families in need. Your time and effort can bring real hope to our community.',
    volunteersFilled: 20,
    volunteersNeeded: 50,
    ageRequirement: '16 years & above',
    whatToBring: ['Comfortable attire', 'Water bottle', 'Positive attitude'],
    additionalInfo: ['Certificate of Appreciation', 'Refreshments provided']
  },
  {
    id: 'funscape-outing',
    tag: 'Youth',
    tagColor: 'bg-indigo-800',
    title: 'FunScape Outing',
    org: 'East Coast Park',
    location: 'East Coast Park',
    date: 'Sat, 12 Sep 2026',
    time: '10:00 AM – 4:00 PM',
    image: 'https://images.unsplash.com/photo-1536331148080-d164fc972561?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1536331148080-d164fc972561?w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1536331148080-d164fc972561?w=1200&q=80',
      'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=1200&q=80'
    ],
    carouselExtra: { type: 'map', label: 'East Coast Park' },
    description: 'Chaperone a fun-filled outing for youths at East Coast Park. Help supervise activities and create joyful memories.',
    volunteersFilled: 8,
    volunteersNeeded: 20,
    ageRequirement: '18 years & above',
    whatToBring: ['Comfortable attire', 'Water bottle', 'Positive attitude'],
    additionalInfo: ['Certificate of Appreciation', 'Refreshments provided']
  },
  {
    id: 'grounded-youth-forum',
    tag: 'Youth',
    tagColor: 'bg-indigo-800',
    title: 'Grounded - A Youth Forum',
    org: 'Madrasah Alsagoff',
    location: 'Madrasah Alsagoff',
    date: 'Sun, 20 Sep 2026',
    time: '2:00 PM – 5:00 PM',
    image: 'https://images.unsplash.com/photo-1655337690436-98778f38d613?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1655337690436-98778f38d613?w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1655337690436-98778f38d613?w=1200&q=80',
      'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1200&q=80'
    ],
    carouselExtra: { type: 'map', label: 'Madrasah Alsagoff' },
    description: 'Facilitate small-group discussions at our youth forum on resilience and identity. No experience needed, just a listening ear.',
    volunteersFilled: 5,
    volunteersNeeded: 15,
    ageRequirement: '18 years & above',
    whatToBring: ['Comfortable attire', 'Water bottle', 'Positive attitude'],
    additionalInfo: ['Certificate of Appreciation']
  }
];

export const mockVolunteers = [
  { id: 1, name: 'Nur Aisyah', role: 'Distribution Lead', initials: 'NA' },
  { id: 2, name: 'Razif Hamid', role: 'Logistics', initials: 'RH' },
  { id: 3, name: 'Siti Zulaikha', role: 'Packing Support', initials: 'SZ' },
  { id: 4, name: 'Ahmad Farid', role: 'Collection Point', initials: 'AF' },
  { id: 5, name: 'Nurul Huda', role: 'Distribution', initials: 'NH' },
  { id: 6, name: 'Zainab Osman', role: 'Packing Support', initials: 'ZO' },
  { id: 7, name: 'Yusof Ismail', role: 'Logistics', initials: 'YI' },
  { id: 8, name: 'Aisha Rahman', role: 'Collection Point', initials: 'AR' },
  { id: 9, name: 'Hafiz Ibrahim', role: 'Distribution', initials: 'HI' },
  { id: 10, name: 'Mariam Bakar', role: 'Packing Support', initials: 'MB' },
  { id: 11, name: 'Faizal Karim', role: 'Logistics', initials: 'FK' },
  { id: 12, name: 'Sarah Yusof', role: 'Collection Point', initials: 'SY' }
];

export const chatSeeds = {
  'mosque-donation-drive': [
    { id: 1, sender: 'me', text: "Hi! I'm interested to join the MDD. Could you let me know which deployment areas are available?", time: '10:24 AM' },
    { id: 2, sender: 'org', text: "Hi Nur Aisyah! Thanks for your interest!\nWe currently have slots for:\n• Masjid collection point\n• Distribution to nearby rental blocks\n• Logistics & packing support\n\nWhich area are you most comfortable with?", time: '10:28 AM' },
    { id: 3, sender: 'me', text: 'I\u2019m happy to help with distribution. Also, I have a gluten intolerance. Are there any food/snacks provided?', time: '10:34 AM' },
    { id: 4, sender: 'org', text: "Great! We'll slot you for distribution. No worries, we'll make sure there are suitable options for you.\nLooking forward to having you with us! 💚", time: '10:36 AM' }
  ],
  'funscape-outing': [
    { id: 1, sender: 'me', text: "Hi! I'd love to help chaperone the FunScape outing. What time should I arrive?", time: '9:10 AM' },
    { id: 2, sender: 'org', text: 'Hi! Thanks for signing up 🎉\nPlease arrive by 9:30 AM at the East Coast Park main entrance. We\u2019ll do a short briefing before the outing starts.', time: '9:14 AM' },
    { id: 3, sender: 'me', text: 'Got it! Should I bring anything specific for the kids?', time: '9:16 AM' },
    { id: 4, sender: 'org', text: "Just sunblock and a water bottle for yourself — we'll provide snacks and activity materials for the group. See you there!", time: '9:20 AM' }
  ],
  'grounded-youth-forum': [
    { id: 1, sender: 'me', text: "Hi, I'm interested in facilitating a discussion group. Do I need prior experience?", time: '3:02 PM' },
    { id: 2, sender: 'org', text: 'Hi there! No prior experience needed — we\u2019ll send you a short facilitator guide beforehand. Just bring a listening ear and an open mind!', time: '3:06 PM' },
    { id: 3, sender: 'me', text: 'Sounds good. How many youths will be in each group?', time: '3:08 PM' },
    { id: 4, sender: 'org', text: "Around 6-8 youths per group. We'll pair you with a co-facilitator too. Looking forward to having you!", time: '3:11 PM' }
  ],
  'fiqh-janazah-course': [
    { id: 1, sender: 'me', text: 'Hi! Is this course suitable for someone with no prior background in fiqh?', time: '11:00 AM' },
    { id: 2, sender: 'org', text: 'Assalamualaikum! Yes, this course is designed for beginners. We start from the basics of janazah rites before going into detailed fiqh discussions.', time: '11:05 AM' },
    { id: 3, sender: 'me', text: 'Great, and is this SkillsFuture claimable?', time: '11:07 AM' },
    { id: 4, sender: 'org', text: 'Yes it is! You can use your SkillsFuture Credits to offset the course fee. We\u2019ll share the claim steps once you\u2019re enrolled.', time: '11:10 AM' }
  ],
  'hackathon-course': [
    { id: 1, sender: 'me', text: 'Hi! Do I need a team to join the hackathon, or can I join solo?', time: '6:30 PM' },
    { id: 2, sender: 'org', text: "Hi! You can join solo — we'll help match you with a team on the day based on interests and skills.", time: '6:34 PM' },
    { id: 3, sender: 'me', text: 'Awesome. What kind of problems will we be solving?', time: '6:36 PM' },
    { id: 4, sender: 'org', text: 'Community-focused challenges — think volunteer matching, elderly care reminders, or donation tracking. Come with curiosity, we\u2019ll guide the rest!', time: '6:40 PM' }
  ],

  // ---- Dialysis centres ----
  'henderson-centre': [
    { id: 1, sender: 'me', text: 'Assalamualaikum. My father needs to start dialysis. Do you have any morning slots at Henderson?', time: '9:02 AM' },
    { id: 2, sender: 'org', text: "Waalaikumsalam! Yes, we have two openings in the 7am shift from next week.\nMay I know if he'll be coming on his own or with a caregiver?", time: '9:08 AM' },
    { id: 3, sender: 'me', text: "He'd come with me, but I work from 9. Is transport something you can help with?", time: '9:12 AM' },
    { id: 4, sender: 'org', text: 'We can arrange transport for the 7am shift — pickup around 6:20am from your block. Our team will call you today to confirm the address.', time: '9:15 AM' }
  ],
  'nooris-centre': [
    { id: 1, sender: 'me', text: 'Hi, I work full-time. Are the evening shifts at Nooris usually full?', time: '2:40 PM' },
    { id: 2, sender: 'org', text: 'Hi! The 6pm shift has a short waitlist, usually about two weeks. We can put you on it and offer you a 1pm slot in the meantime if that helps.', time: '2:46 PM' },
    { id: 3, sender: 'me', text: 'That works. Can my wife wait with me during sessions?', time: '2:49 PM' },
    { id: 4, sender: 'org', text: 'Of course — we have a family lounge right beside the treatment room with prayer space and refreshments.', time: '2:52 PM' }
  ],
  'yishun-centre': [
    { id: 1, sender: 'me', text: 'Salam, I stay in Sembawang. Is Yishun Centre reachable without a car?', time: '11:20 AM' },
    { id: 2, sender: 'org', text: 'Salam! Yes — it is a sheltered five-minute walk from Khatib MRT, and bus 858 stops right outside.', time: '11:24 AM' },
    { id: 3, sender: 'me', text: 'Good to know. I read that you train patients for home dialysis?', time: '11:27 AM' },
    { id: 4, sender: 'org', text: "We do — it's a six-week programme with our renal nurses. Happy to assess suitability once you've had your first few sessions with us.", time: '11:31 AM' }
  ],

  // ---- Casket packages ----
  'casket-standard': [
    { id: 1, sender: 'me', text: 'What exactly is covered in the $1,800 package? I want to be clear before I commit.', time: '8:15 PM' },
    { id: 2, sender: 'org', text: 'Assalamualaikum. It covers collection, ghusl and kafan, the casket, transport, the burial plot at Pusara Aman, and all permit paperwork.\nThere are no add-on charges.', time: '8:19 PM' },
    { id: 3, sender: 'me', text: 'And if we want the solat janazah at our own mosque?', time: '8:21 PM' },
    { id: 4, sender: 'org', text: "That's included — tell us the mosque and we'll coordinate the timing with them directly.", time: '8:24 PM' }
  ],
  'casket-subsidised': [
    { id: 1, sender: 'me', text: 'My family cannot afford the full amount right now. Is the subsidised package means-tested?', time: '10:05 PM' },
    { id: 2, sender: 'org', text: 'It is, but please do not worry about that tonight. We proceed with the service first and our officer completes the assessment with you afterwards.', time: '10:08 PM' },
    { id: 3, sender: 'me', text: 'So we would not need to pay anything upfront?', time: '10:10 PM' },
    { id: 4, sender: 'org', text: 'Nothing upfront. No family is turned away — that is the whole point of this package. Shall we send a team now?', time: '10:12 PM' }
  ],

    // ---- Core services ----
  'financial-assistance': [
    { id: 1, sender: 'org', text: 'Assalamualaikum. You can start an application here any time — it takes about 10 minutes.', time: '9:02 AM' },
    { id: 2, sender: 'me', text: 'Do I need payslips? My husband is doing odd jobs now.', time: '9:20 AM' },
    { id: 3, sender: 'org', text: 'No payslips needed for irregular income. A short written declaration is enough, and your caseworker will help you write it.', time: '9:26 AM' }
  ],
  'ihsan-casket': [
    { id: 1, sender: 'org', text: 'Our line is open 24/7 on 9123 4567 for an immediate death report.', time: '11:40 PM' },
    { id: 2, sender: 'me', text: 'My father is still in hospital. Can I arrange things in advance?', time: '11:52 PM' },
    { id: 3, sender: 'org', text: 'Yes, and many families do. We hold the arrangements without any charge until they are needed.', time: '11:58 PM' }
  ],
  bursaries: [
    { id: 1, sender: 'org', text: 'The intake is open now and closes at the end of the term.', time: '2:15 PM' },
    { id: 2, sender: 'me', text: 'I have three children in different schools. Separate forms?', time: '3:01 PM' },
    { id: 3, sender: 'org', text: 'One form for the whole household — just add each child inside it.', time: '3:08 PM' }
  ],
  'ulum-asatizah': [
    { id: 1, sender: 'org', text: 'Assalamualaikum Ustadz. Log each session after class — date, hours, host and roll call. That is what finance uses for your timesheet.', time: '8:10 PM' },
    { id: 2, sender: 'me', text: 'If I teach two classes this week, two separate logs?', time: '8:14 PM' },
    { id: 3, sender: 'org', text: 'Yes — one submission per session. Uncheck only the students who were absent. Host location stays on the form as evidence.', time: '8:16 PM' }
  ],
  'daily-attendance': [
    { id: 1, sender: 'org', text: 'Assalamualaikum. This register is staff-only. Tap a case number — never a name — then log attendance or movement.', time: '7:40 AM' },
    { id: 2, sender: 'me', text: 'If a resident is still out after the expected return?', time: '7:42 AM' },
    { id: 3, sender: 'org', text: 'The tile and the whereabouts board turn red. Log the return from that row. Every entry is stamped with the duty officer.', time: '7:44 AM' }
  ],
  'kidney-care': [
    { id: 1, sender: 'org', text: 'We can place you at Henderson, Nooris or Yishun, whichever is nearest.', time: '10:05 AM' },
    { id: 2, sender: 'me', text: 'My mother cannot take the bus alone. Is there transport?', time: '10:31 AM' },
    { id: 3, sender: 'org', text: 'Yes — we arrange door-to-door transport for patients who need it, at no extra cost.', time: '10:37 AM' }
  ],

  // ---- Giving ----
  'give-darul-ihsan': [
    { id: 1, sender: 'me', text: 'Hi! If I donate to the orphanages, does it go to a specific child or to the home generally?', time: '4:02 PM' },
    { id: 2, sender: 'org', text: 'Hi! It goes to the home generally, which lets us cover whatever is most needed that month — school fees, medical, or enrichment.', time: '4:06 PM' },
    { id: 3, sender: 'me', text: 'Can I visit and see the work sometime?', time: '4:08 PM' },
    { id: 4, sender: 'org', text: 'Yes, we run donor visits every quarter. We\u2019ll add you to the invite list once your first gift goes through. 💚', time: '4:11 PM' }
  ],
  'give-sedekah-subuh': [
    { id: 1, sender: 'me', text: 'Salam, how does the daily Sedekah Subuh actually get charged?', time: '7:30 AM' },
    { id: 2, sender: 'org', text: 'Salam! Your card is charged the same small amount each morning. Most donors set $1 or $2 so it stays effortless.', time: '7:34 AM' },
    { id: 3, sender: 'me', text: 'And if my card fails one day?', time: '7:36 AM' },
    { id: 4, sender: 'org', text: 'We simply skip that day and try the next — nothing accumulates and you are never billed twice.', time: '7:38 AM' }
  ],
  'give-jumaat': [
    { id: 1, sender: 'me', text: 'Does the weekly Jumaat donation go anywhere specific?', time: '1:15 PM' },
    { id: 2, sender: 'org', text: 'It goes to households currently waiting in our assistance queue — usually rental arrears, utilities and school needs.', time: '1:19 PM' },
    { id: 3, sender: 'me', text: 'Can I change the amount later?', time: '1:21 PM' },
    { id: 4, sender: 'org', text: 'Anytime, from the Me tab. Change it, pause it during a tight month, or resume when you\u2019re ready.', time: '1:23 PM' }
  ],
  'give-monthly': [
    { id: 1, sender: 'me', text: 'What does a $50 monthly donation actually pay for?', time: '5:40 PM' },
    { id: 2, sender: 'org', text: 'Roughly one subsidised dialysis session a month for a patient who could not otherwise afford it.', time: '5:44 PM' },
    { id: 3, sender: 'me', text: "That's clearer than I expected. Do I get a yearly receipt?", time: '5:46 PM' },
    { id: 4, sender: 'org', text: 'Yes — one consolidated tax-deductible receipt each January, at 2.5 times your total giving.', time: '5:49 PM' }
  ],
  'give-once-off': [
    { id: 1, sender: 'me', text: 'I want to give once in my late mother\u2019s name. Is that possible?', time: '9:50 PM' },
    { id: 2, sender: 'org', text: 'It is, and may Allah grant her the highest place. Add her name in the checkout notes and we\u2019ll record the gift under it.', time: '9:55 PM' },
    { id: 3, sender: 'me', text: 'Thank you. Will I get a receipt straight away?', time: '9:57 PM' },
    { id: 4, sender: 'org', text: 'Emailed the moment the payment clears, with her name on it. 🤲', time: '9:59 PM' }
  ]
};


export const learnHubItems = [
  {
    id: 'ulum-ihsan-course',
    tag: 'Islamic Studies',
    tagColor: 'bg-primary',
    title: 'Ulum Ihsan',
    org: 'Community Learning',
    location: 'Online & In-person',
    date: 'Ongoing enrolment',
    image: 'https://images.unsplash.com/photo-1589995635011-078e0bb91d11?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1589995635011-078e0bb91d11?w=1200&q=80',
    description: 'A structured Islamic learning path covering Fardhu Ain, Dua & Surah reading, and attendance tracking — a bite-sized mini learning journey for every learner.',
    isLMS: true
  },
  {
    id: 'fiqh-janazah-course',
    tag: 'Professional',
    tagColor: 'bg-indigo-800',
    title: 'Fiqh Janazah',
    org: 'filament.sg',
    location: 'Classroom · MTFA',
    date: 'Sat, 5 Sep 2026',
    time: '9:00 AM – 5:00 PM',
    image: 'https://images.unsplash.com/photo-1569929919600-59123640bc02?w=800&q=80',
    heroImage: '/images/mtfa-ihsan-casket.jpg',
    images: [
      '/images/mtfa-ihsan-casket.jpg',
      'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1200&q=80'
    ],
    carouselExtra: {
      type: 'program',
      items: [
        { time: '9:00 AM', label: 'Registration & Refreshments' },
        { time: '9:30 AM', label: 'Fiqh of Ghusl & Kafan (washing & shrouding)' },
        { time: '12:30 PM', label: 'Lunch & Zuhr Break' },
        { time: '2:00 PM', label: 'Funeral Prayer & Burial Rites' },
        { time: '4:30 PM', label: 'Q&A and Certification' }
      ]
    },
    description: 'Learn the Islamic jurisprudence (fiqh) of funeral rites — from washing and shrouding to burial prayers — taught by certified asatizah. SkillsFuture eligible.',
    volunteersFilled: 14,
    volunteersNeeded: 25,
    ageRequirement: '18 years & above',
    whatToBring: ['Comfortable attire', 'Notebook & pen', 'Positive attitude'],
    additionalInfo: ['Certificate of Appreciation', 'Refreshments provided']
  },
  {
    id: 'hackathon-course',
    tag: 'Community Skills',
    tagColor: 'bg-amber-600',
    title: 'Hackathon',
    org: 'IhsanOne Tech Community',
    location: 'Community Hub',
    date: 'Sat–Sun, 19–20 Sep 2026',
    time: '9:00 AM – 6:00 PM',
    image: 'https://images.unsplash.com/photo-1719159381981-1327b22aff9b?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1719159381981-1327b22aff9b?w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1719159381981-1327b22aff9b?w=1200&q=80',
      'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80'
    ],
    carouselExtra: {
      type: 'program',
      items: [
        { time: 'Day 1, 9:00 AM', label: 'Kickoff & Team Formation' },
        { time: 'Day 1, 11:00 AM', label: 'Ideation & Mentorship' },
        { time: 'Day 2, 10:00 AM', label: 'Build Sprint' },
        { time: 'Day 2, 4:00 PM', label: 'Pitching & Judging' },
        { time: 'Day 2, 6:00 PM', label: 'Awards & Closing' }
      ]
    },
    description: 'A weekend hackathon for youths and volunteers to build simple tech solutions for community problems. No experience needed — just curiosity and teamwork.',
    volunteersFilled: 18,
    volunteersNeeded: 40,
    ageRequirement: '16 years & above',
    whatToBring: ['Laptop', 'Water bottle', 'Positive attitude'],
    additionalInfo: ['Certificate of Appreciation', 'Refreshments provided']
  }
];

export const ulumIhsanData = {
  learnerName: 'Siti',
  modulesCompleted: 1,
  modulesTotal: 3,
  fardhuAin: {
    level: 'Level 1',
    title: 'Essentials of Islamic knowledge & practices',
    description: 'Learn the basics of Islam — your Fardhu Ain — so you can live a better life, in this world and the hereafter.',
    heroImage: '/images/learn-hub-hero.jpeg',
    lessons: [
      { id: 1, title: 'The 5 Pillars of Islam', videoId: '3OETIBp31zM', description: 'The five foundational acts of worship every Muslim observes: Shahada, Salah, Zakat, Sawm and Hajj.' },
      { id: 2, title: 'The 6 Articles of Faith', videoId: 'md1vVViAZ0w', description: 'The core beliefs of Islam: belief in Allah, the Angels, the Books, the Prophets, the Day of Judgment, and Al-Qadr.' },
      { id: 3, title: 'Wudu & Salah (Prayer)', videoId: 'LZWe0Xh-Hfc', description: 'A step-by-step guide to performing ablution (wudu) and the daily prayers (salah) correctly.' },
      { id: 4, title: 'Quran & Sunnah', videoId: 'zBWjfY3QPuY', description: 'An introduction to the two primary sources of Islamic guidance — the Quran and the Sunnah of the Prophet \u0645.' },
      { id: 5, title: 'Good Manners in Islam', videoId: '2A4YsKd0Bp4', description: 'Everyday adab (manners) taught in Islam — kindness, honesty, and good character in daily life.' }
    ]
  },
  duaSurah: {
    level: 'Level 1',
    title: 'Basic reading proficiency',
    description: 'Learn to read simple Duas and Surahs with correct pronunciation and meaning.',
    heroImage: '/images/ulum-ihsan-dua-surah-hero.jpeg',
    weeklyLesson: {
      title: 'Surah Al-Fatihah',
      description: 'Learn to read Surah Al-Fatihah with tajweed and understand its meaning.',
      videoId: '53oOYUfkEX8',
      duration: '3:45'
    }
  }
};

// Mock "My Engagements" — items the user is assigned to, applied for, or enrolled in,
// grouped by top-tab category (assistance/learn/volunteer/give). Used by the Me tab and
// by the Assistance filter on the Saved tab.
export const myEngagements = {
  services: [
    { id: 'app-financial-assistance', title: 'Financial Assistance — Ihsan Aid', status: 'Under Review', meta: 'Applied 12 Aug 2026', icon: 'hand-coins' },
    { id: 'app-kidney-care', title: 'Kidney Care Subsidy', status: 'Approved', meta: 'Active since 2 Jul 2026', icon: 'heart' }
  ],
  learn: [
    { id: 'eng-ulum-ihsan', title: 'Ulum Ihsan', status: '40% complete', meta: 'Last lesson: 3 Aug 2026', image: 'https://images.unsplash.com/photo-1589995635011-078e0bb91d11?w=200&q=80' }
  ],
  volunteer: [
    { id: 'eng-mdd', title: 'Mosque Donation Drive (MDD)', status: 'Confirmed', meta: 'Sat, 30 Aug 2026', image: 'https://images.unsplash.com/photo-1569929919600-59123640bc02?w=200&q=80' }
  ],
  give: [
    { id: 'eng-ramadan-food', title: 'Ramadan Food Packages', status: 'Donated $50', meta: '12 Aug 2026', image: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?w=200&q=80' }
  ]
};


// When each conversation was last active. The inbox shows the date rather than
// the clock time and sorts on this, so the newest thread is always on top.
export const chatUpdatedAt = {
  'financial-assistance': '2026-09-09',
  'casket-subsidised': '2026-09-09',
  'henderson-centre': '2026-09-09',
  'ihsan-casket': '2026-09-08',
  'kidney-care': '2026-09-07',
  bursaries: '2026-09-04',
  'ulum-asatizah': '2026-09-09',
  'daily-attendance': '2026-09-09',
  'give-once-off': '2026-09-08',
  'casket-standard': '2026-09-08',
  'give-monthly': '2026-09-07',
  'nooris-centre': '2026-09-06',
  'give-jumaat': '2026-09-05',
  'mosque-donation-drive': '2026-09-04',
  'yishun-centre': '2026-09-03',
  'give-darul-ihsan': '2026-09-02',
  'grounded-youth-forum': '2026-08-30',
  'give-sedekah-subuh': '2026-08-28',
  'fiqh-janazah-course': '2026-08-25',
  'funscape-outing': '2026-08-21',
  'hackathon-course': '2026-08-14'
};

// Every collection whose items have a card, a detail page and a chat thread.
// The chat inbox and chat routing iterate this, so registering a collection
// here is all that's needed for it to appear everywhere.
export const detailCollections = {
  services: serviceHubItems,
  volunteer: volunteerHubItems,
  learn: learnHubItems,
  give: givingOptions,
  dialysis: dialysisCentres,
  casket: casketPackages
};
